export default {
  eventImages: [],
  eventImage: undefined,
};
